import BaseApi from "./BaseApi";

/** PDF の生成には時間がかかるため、既定（30 秒）より長くする */
const GENERATE_PDF_TIMEOUT_MS = 60000;

/**
 * 日誌の PDF を backend（rust-pdf）で生成する（POST /diaries/generate-pdf、issue #993 / #995）
 *
 * 認証トークン（契約社員・Auth0）の付与は BaseApi のインターセプターが行う。
 *
 * @param {Object} diary 日誌（pdf-api に送る json_data と同じ形。siteMetaData を含む）
 * @returns {Promise} 応答の data は `{ pdfData: <base64>, fileName }`
 */
export function generateDiaryPdf(diary) {
  return BaseApi.post(
    "/diaries/generate-pdf",
    { diary },
    { timeout: GENERATE_PDF_TIMEOUT_MS }
  );
}

export default {
  generateDiaryPdf,
};
